import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {AddOutlined, DeleteOutlined, EditOutlined} from '@material-ui/icons';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import useConfirmationDialog from '../../../shared/confirmationdialog/useConfirmationDialog.js';
import {buttonTableCell} from '../../../../utils/styles.js';
import {criarColunaOpcoes} from '../../components/ColunaOpcoes.jsx';
import {ouTraco} from '../../components/inscricao/documentoInscricao.js';
import {PAGINACAO_PADRAO} from '../../components/paginacao.js';
import {formatarData, salvarItemNaLista} from '../../components/processo/processoSelecao.js';
import DialogCalendarioProcesso from '../../dialogs/processo/DialogCalendarioProcesso.jsx';

const TABLE_CONTAINER_PROPS = {component: 'div'};

const useStyles = makeStyles(theme => ({
    ...buttonTableCell(theme)
}));

/* Aba "Calendários": tipo e período (só datas) de cada calendário do processo de seleção. */
export default function TabCalendarios({watch, setValue, tiposCalendario = []}) {
    const classes = useStyles();
    const confirmation = useConfirmationDialog();
    // Índice do calendário em edição: -1 para adicionar, null com o diálogo fechado.
    const [indiceCalendario, setIndiceCalendario] = useState(null);

    const calendarios = watch('calendarios') || [];

    const salvar = calendario => setValue('calendarios', salvarItemNaLista(calendarios, calendario, indiceCalendario ?? -1), {shouldDirty: true});

    const remover = posicao => {
        confirmation('Tem certeza que deseja remover esse calendário?', () =>
            setValue('calendarios', calendarios.filter((item, atual) => atual !== posicao), {shouldDirty: true}));
    };

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <DataGrid
                        toolbarContent={(
                            <ContainedButton startIcon={<AddOutlined/>} onClick={() => setIndiceCalendario(-1)}>Adicionar</ContainedButton>
                        )}
                        tableContainerProps={TABLE_CONTAINER_PROPS}
                        rows={calendarios}
                        paginate
                        paginateOptions={PAGINACAO_PADRAO}
                        noRecordsText='Nenhum calendário registrado.'
                        columns={[
                            {label: 'Tipo', field: 'descricaoTipo', valueGetter: valor => ouTraco(valor)},
                            {label: 'Data inicial', field: 'dataInicial', valueGetter: valor => formatarData(valor)},
                            {label: 'Data final', field: 'dataFinal', valueGetter: valor => formatarData(valor)},
                            criarColunaOpcoes(row => {
                                const posicao = calendarios.indexOf(row);
                                return [
                                    {titulo: 'Editar', icone: <EditOutlined/>, onClick: () => setIndiceCalendario(posicao)},
                                    {titulo: 'Excluir', icone: <DeleteOutlined/>, onClick: () => remover(posicao)}
                                ];
                            }, {className: classes.buttonTableCell})
                        ]}/>
                </Grid>
            </Grid>
            <DialogCalendarioProcesso
                open={indiceCalendario !== null}
                onClose={() => setIndiceCalendario(null)}
                calendario={indiceCalendario !== null && indiceCalendario > -1 ? calendarios[indiceCalendario] : null}
                tiposCalendario={tiposCalendario}
                onSalvar={salvar}/>
        </>
    );
}

TabCalendarios.propTypes = {
    watch: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    /* Tipos do apoio: [{id, descricao}]. */
    tiposCalendario: PropTypes.array
};
